import {ReactNode} from "react";
import {StyleSheet, Text} from "react-native";
import {Color} from "@/lib/styles";

type Props = {
    children?: ReactNode;
}

export default function PrimaryText({children}: Props) {
    return <Text style={styles.text}>{children}</Text>
}

export const styles = StyleSheet.create({
    text: {
        fontSize: 16,
        color: Color.PrimaryText,
    },
})